<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          to="/add-pointage-notes"
          v-if="auth.can('SCORING')"
        >
          Ajouter un bon de suivi livreur
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 mb-4">
      <div class="row align-items-end">
        <!-- RAMASSEUR -->
        <div class="col-md-4 mb-3">
          <label>Ramasseur</label>
          <v-select
            v-model="ramass_filter"
            :options="RamassList"
            label="name"
            placeholder="Tous les ramasseurs"
            @search="onSearchRamass"
          >
            <template #no-options>
              Taper un mot pour chercher un ramasseur
            </template>
          </v-select>
        </div>

        <!-- STATUT -->
        <div class="col-md-4 mb-3">
          <label>Statut</label>
          <select class="form-control" v-model="filters.searchStatut">
            <option value="">Statut (Tous)</option>
            <option :value="0">Brouillon</option>
            <option :value="1">Enregistré</option>
          </select>
        </div>

        <!-- CRÉÉ PAR -->
        <div class="col-md-4 mb-3">
          <label>Créé par</label>
          <v-select
            v-model="filters.searchUser"
            :options="UsersList"
            label="name"
            :reduce="(u) => u.id"
            placeholder="Tous les utilisateurs"
            @search="onSearchUsers"
          >
            <template #no-options>
              Taper un mot pour chercher un utilisateur
            </template>
          </v-select>
        </div>

        <!-- DATE -->
        <div class="col-md-4 mb-3">
          <label>Date</label>
          <input
            type="date"
            class="form-control"
            v-model="filters.searchDate"
          />
        </div>

        <!-- SEARCH -->
        <div class="col-md-4 mb-3">
          <label>Recherche</label>
          <input
            type="text"
            class="form-control"
            placeholder="Chercher..."
            v-model="filters.searchTerm"
            @input="handleInput"
          />
        </div>

        <!-- ACTIONS -->
        <div class="col-md-12 mt-2">
          <button class="btn btn-primary me-2" @click="applyFilters">
            Filtrer
          </button>

          <button class="btn btn-outline-danger" @click="resetFilters">
            Annuler
          </button>
        </div>
      </div>

      <hr class="mb-4" />
      <div class="row mb-20">
        <div class="col-md-6 d-flex align-items-center">
          <label>Voir</label>
          <v-select
            v-model="filters.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRecords()"
          />
          <label>sur {{ filters.total }} entités</label>
        </div>
      </div>

      <vue-good-table :columns="columns" :rows="rows">
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <template v-if="props.column.field === 'note_ref'">
            <b>{{ props.row.note_ref }}</b>
          </template>

          <template v-else-if="props.column.field === 'user_name'">
            <b>{{ props.row.user_name }}</b>
          </template>

          <template v-else-if="props.column.field === 'created_at'">
            <template v-if="props.row.created_at != null">
              {{ getDate(props.row.created_at) }}
              <br />
            </template>
            {{ props.row.note_by_name }}
          </template>

          <template v-else-if="props.column.field === 'statut'">
            <span
              v-if="props.row.statut == 0"
              class="badge text-bg-warning fs-13"
            >
              Brouillon
            </span>
            <span v-else class="badge text-bg-success fs-13"> Enregistré </span>
          </template>

          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <router-link
                    v-if="auth.can('SCORING')"
                    class="dropdown-item d-flex align-items-center"
                    :to="{
                      name: 'PointageDetailsPage',
                      params: { id: props.row.id, ref: props.row.note_ref },
                    }"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </router-link>
                </li>
                <li v-if="props.row.statut == 0 && props.row.total_notes == 0">
                  <button
                    v-if="auth.can('SCORING')"
                    class="dropdown-item d-flex align-items-center"
                    @click="removeNote(props.row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </button>
                </li>
                <li v-if="props.row.statut == 0 && props.row.total_notes != 0">
                  <button
                    v-if="auth.can('SCORING')"
                    class="dropdown-item d-flex align-items-center"
                    @click="saveBon(props.row)"
                  >
                    <i
                      class="flaticon-check lh-1 me-8 position-relative top-1"
                    ></i>
                    Enregistrer
                  </button>
                </li>
                <li v-if="props.row.statut == 1">
                  <button
                    v-if="auth.can('SCORING')"
                    class="dropdown-item d-flex align-items-center"
                    @click="unSaveBon(props.row)"
                  >
                    <i
                      class="flaticon-edit lh-1 me-8 position-relative top-1"
                    ></i>
                    Ouvrir
                  </button>
                </li>
                <li v-if="props.row.total_notes != 0">
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="getPDF(props.row)"
                  >
                    <i
                      class="flaticon-printer lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </button>
                </li>
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted, reactive, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";

export default {
  name: "ListeNotesPointage",
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();

    const rows = ref([]);
    const isLoader = ref(false);

    const ramass_filter = ref({ id: "", name: "" });

    const columns = [
      {
        label: "Référence",
        field: "note_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Ramasseur",
        field: "user_name",
      },
      {
        label: "Bons",
        field: "total_notes",
      },
      {
        label: "Statut",
        field: "statut",
      },
      {
        label: "Actions",
        field: "action",
      },
    ];

    const filters = reactive({
      searchTerm: "",
      searchRamass: "",
      searchStatut: "",
      searchUser: "",
      searchDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    onMounted(() => {
      getRecords();
    });

    async function getRecords(page = 1) {
      filters.current_page = page;
      isLoader.value = true;
      try {
        const response = await api.get(
          `/api/auth/pointageList?searchRamass=${filters.searchRamass}&searchUser=${filters.searchUser}&searchStatut=${filters.searchStatut}&searchDate=${filters.searchDate}&searchTerm=${filters.searchTerm}&page=${filters.current_page}&per_page=${filters.per_page}`
        );

        rows.value = response.data.users.data;
        Object.assign(filters, response.data.users);
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function handleInput() {
      applyFilters();
    }

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/ReturnPointPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF",
        });
      }
    }

    async function removeNote(row) {
      const result = await Swal.fire({
        text: "Vous voulez supprimer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/removeNotePoint/${row.id}`);

          if (res.data.message === "success") {
            showToast("Bon est bien supprimé", "success");
            getRecords();
          } else {
            showToast("Vous ne pouvez pas le supprimer!", "error");
          }
        } catch (error) {
          console.error("Erreur suppression :", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }

    async function saveBon(row) {
      const result = await Swal.fire({
        text: "Vous voulez enregistrer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, enregistrer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/saveNotePoint/${row.id}`);

          if (res.data.message === "success") {
            showToast("Bon est bien enregistré", "success");
            getRecords();
          } else {
            showToast("Vous ne pouvez pas le enregistrer!", "error");
          }
        } catch (error) {
          console.error("Erreur enregistrement :", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }

    async function unSaveBon(row) {
      const result = await Swal.fire({
        text: "Vous voulez ouvrir ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, ouvrir!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/unSaveNotePoint/${row.id}`);

          if (res.data.message === "success") {
            showToast("Bon est bien ouvert", "success");
            getRecords();
          } else {
            showToast("Vous ne pouvez pas l'ouvrir!", "error");
          }
        } catch (error) {
          console.error("Erreur :", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }

    function applyFilters() {
      filters.searchRamass = ramass_filter.value?.id || "";
      filters.current_page = 1;
      getRecords(1);
    }

    function resetFilters() {
      Object.assign(filters, {
        searchRamass: "",
        searchStatut: "",
        searchUser: "",
        searchTerm: "",
        searchDate: "",
        current_page: 1,
      });
      ramass_filter.value = { id: "", name: "" };

      getRecords(1);
    }

    const RamassList = ref([]);
    const UsersList = ref([]);

    async function onSearchUsers(search, loading) {
      if (!search || UsersList.value.length > 0) return;

      loading(true);

      try {
        const response = await api.get("/api/auth/SelectList");
        UsersList.value = response.data || [];

        UsersList.value.unshift({ id: "", name: "Tous" });
      } catch (error) {
        console.error("Erreur chargement utilisateurs:", error);
      } finally {
        loading(false);
      }
    }

    async function onSearchRamass(search, loading) {
      if (!search || RamassList.value.length > 0) return;

      loading(true);

      try {
        const response = await api.get("/api/auth/userListPickup");
        RamassList.value = response.data || [];

        RamassList.value.unshift({ id: "", name: "Tous les ramasseurs" });
      } catch (error) {
        console.error("Erreur chargement ramasseurs:", error);
      } finally {
        loading(false);
      }
    }

    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      getDate,
      handleInput,
      getPDF,

      removeNote,
      saveBon,
      unSaveBon,

      resetFilters,
      applyFilters,
      RamassList,
      UsersList,
      onSearchUsers,
      onSearchRamass,

      ramass_filter,
    };
  },
};
</script>
